import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actionUpdateReportCv } from '../../../../redux/action/userSingleReport/actionUserSingleReport';
import { formatReportData } from '../../../../utils/formatReportData';
import { AppDispatch } from '../../../../redux/reducer/store';
import { IReportSkuCvOptions } from '../../../../types/reportsInterfaces';

import EditPopup from '../../../custom/editPopup/editPopup';
import ArrowIcon from '../../../../assets/icons/chevron.svg';
import { IUserOptions } from '../../../../types/interfaces';

const CvTableSection: FC = () => {
	const dispatch = useDispatch<AppDispatch>();

	const { report } = useSelector(
		(state: any) => state.userSingleReport.userSingleReport
	);
	const { claims } = useSelector((state: IUserOptions) => state.user.user.data);

	const [openOutletHotlineIndex, setOpenOutletHotlineIndex] =
		useState<number>(-1);
	const [openOutletDataIndex, setOpenOutletDataIndex] = useState<number>(-1);
	const [newCvHotline, setNewCvHotline] = useState<string>('');
	const [newCvValue, setNewCvValue] = useState<string>('');
	const [isVisibleData, setIsVisibleData] = useState<boolean>(true);

	const modalRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick);

		return () => {
			document.removeEventListener('mousedown', handleDocumentClick);
		};
	}, []);

	const handleClickCancelRenameBtn = () => {
		setOpenOutletHotlineIndex(-1);
		setOpenOutletDataIndex(-1);
	};

	const handleChangeReportData = (index: number, section: string) => {
		const sectionToStateMap: any = {
			outletData: {
				setState: setOpenOutletDataIndex,
				state: openOutletDataIndex,
			},
			outletHotline: {
				setState: setOpenOutletHotlineIndex,
				state: openOutletHotlineIndex,
			},
		};

		const setOpenIndexFunction = sectionToStateMap[section];

		if (setOpenIndexFunction) {
			if (index === setOpenIndexFunction.state) {
				return;
			} else {
				setOpenIndexFunction.setState(index);
			}
		}
	};

	const handleAcceptRenameCv = (elem: IReportSkuCvOptions, typeOfValue: string) => {
		dispatch(
			actionUpdateReportCv({
				reportId: report && report.reportId.id,
				data: [
					{
						name: elem.name,
						value:
							typeOfValue === 'value' ? newCvValue || elem.value : elem.value,
						hotline:
							typeOfValue === 'hotline'
								? newCvHotline || elem.hotline
								: elem.hotline,
					},
				],
			})
		);

		handleClickCancelRenameBtn();
		setNewCvHotline('');
		setNewCvValue('');
	};

	const handleAcceptEditOnKeyPress = (event: React.KeyboardEvent<HTMLInputElement>, elem: IReportSkuCvOptions, type: string) => {
		if (event.key === 'Enter') {
			handleAcceptRenameCv(elem, type);
		}
	};

	const handleDocumentClick = (event: MouseEvent) => {
		if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
			setOpenOutletHotlineIndex(-1);
			setOpenOutletDataIndex(-1);
		}
	};

	const sortedCv: IReportSkuCvOptions[] =
		report?.cv
			?.slice()
			?.sort((a: IReportSkuCvOptions, b: IReportSkuCvOptions) =>
				a.name?.localeCompare(b.name)
			) ?? [];

	const hasAnyWithPlan = sortedCv.some(
		(elem) => elem.category.DisplayWithPlan === 'Выкладка (с планом)'
	);

	return (
		<div className={`sectionData ${isVisibleData ? 'sectionData_active  sectionData__overflow' : ''}`}>
			<span className='section__title'>Данные по ТТ</span>
			<button
				className='sectionData_button'
				onClick={() => setIsVisibleData(!isVisibleData)}
			>
				<img src={ArrowIcon} alt="Custom Indicator" className='icon' />
			</button>
			<table className='customer__skus_table'>
				<thead className='tunder__thead'>
					<tr>
						<th>Наименование</th>
						{hasAnyWithPlan && <th>План</th>}
						<th>Значение</th>
						<th>Горячая линия</th>
					</tr>
				</thead>
				<tbody>
					{report &&
						sortedCv.map((elem: IReportSkuCvOptions, index: number) => {
								return (
									<tr key={index}>
										<td>{elem.name}</td>
										{hasAnyWithPlan && (
											<td>
												{elem.category.DisplayWithPlan === 'Выкладка (с планом)'
													? elem.weightPlan
													: '—'}
											</td>
										)}
										<td
											onClick={() => {
												if (
													claims.includes('admin') ||
													claims.includes('reports:edit')
												) {
													handleChangeReportData(index, 'outletData');
												}
											}}
											className='edit__data_text'
										>
											<div className={
													formatReportData(elem?.changes)?.includes('value')
														? 'changed__table_value'
														: formatReportData(elem?.equals)?.includes('Value')
															? 'previous__table_value'
															: ''
												}>
											<span>
												{elem.value}
											</span>
											</div>
											
											{openOutletDataIndex === index && (
												<EditPopup
													handleClickAcceptRenameBtn={() => {
														handleAcceptRenameCv(elem, 'value');
													}}
													handleAcceptOnKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) =>
														handleAcceptEditOnKeyPress(event, elem, 'value')
													}
													handleClickCancelRenameBtn={handleClickCancelRenameBtn}
													handleChangeValue={(event: React.ChangeEvent<HTMLInputElement>) => {
														setNewCvValue(event?.target.value);
													}}
													defaultValue={elem.value}
													className='edit__popup'
													modalRef={modalRef}
												/>
											)}
										</td>
										<td
											onClick={() => {
												if (
													claims.includes('admin') ||
													claims.includes('reports:edit')
												) {
													handleChangeReportData(index, 'outletHotline');
												}
											}}
											className='edit__data_text'
										>
											<span>{elem.hotline || '—'}</span>
											{openOutletHotlineIndex === index && (
												<EditPopup
													handleClickAcceptRenameBtn={() => {
														handleAcceptRenameCv(elem, 'hotline');
													}}
													handleAcceptOnKeyPress={(event: React.KeyboardEvent<HTMLInputElement>) =>
														handleAcceptEditOnKeyPress(event, elem, 'hotline')
													}
													handleClickCancelRenameBtn={handleClickCancelRenameBtn}
													handleChangeValue={(event: React.ChangeEvent<HTMLInputElement>) => {
														setNewCvHotline(event?.target.value);
													}}
													defaultValue={elem.hotline}
													className='edit__popup'
													modalRef={modalRef}
												/>
											)}
										</td>
									</tr>
								);
							})}
				</tbody>
			</table>
		</div>
	);
};

export default CvTableSection;
